{
  "schemaVersion": 1,
  "currency": "usd",
  "current": {
    "catalogVersion": "v2",
    "status": "current",
    "billingInterval": "month",
    "plans": [
      {
        "plan": "free",
        "label": "Free",
        "monthlyPriceUsdCents": 0,
        "activeProjects": 1,
        "clients": 1,
        "dataWindowDays": 90,
        "reportsPerMonth": 2,
        "syncFrequency": "weekly",
        "qaAccess": false,
        "customRoles": false,
        "distributionRecipients": 3,
        "scheduledBundles": 1,
        "includedCreditsPerPeriod": 0
      },
      {
        "plan": "starter",
        "label": "Starter",
        "monthlyPriceUsdCents": 9900,
        "activeProjects": 3,
        "clients": "unlimited",
        "dataWindowDays": 365,
        "reportsPerMonth": 20,
        "syncFrequency": "daily",
        "qaAccess": true,
        "customRoles": false,
        "distributionRecipients": 25,
        "scheduledBundles": 10,
        "includedCreditsPerPeriod": 300
      },
      {
        "plan": "growth",
        "label": "Growth",
        "monthlyPriceUsdCents": 29900,
        "activeProjects": 10,
        "clients": "unlimited",
        "dataWindowDays": 365,
        "reportsPerMonth": 100,
        "syncFrequency": "daily",
        "qaAccess": true,
        "customRoles": false,
        "distributionRecipients": "unlimited",
        "scheduledBundles": "unlimited",
        "includedCreditsPerPeriod": 1200
      },
      {
        "plan": "scale",
        "label": "Scale",
        "monthlyPriceUsdCents": 79900,
        "activeProjects": 30,
        "clients": "unlimited",
        "dataWindowDays": 365,
        "reportsPerMonth": "unlimited",
        "syncFrequency": "hourly",
        "qaAccess": true,
        "customRoles": true,
        "distributionRecipients": "unlimited",
        "scheduledBundles": "unlimited",
        "includedCreditsPerPeriod": 4000
      }
    ]
  },
  "legacy": {
    "catalogVersion": "v1",
    "status": "legacy",
    "billingInterval": "month",
    "plans": [
      {
        "plan": "free",
        "label": "Free",
        "monthlyPriceUsdCents": 0,
        "activeProjects": "unlimited",
        "clients": 1,
        "dataWindowDays": 90,
        "reportsPerMonth": 2,
        "syncFrequency": "weekly",
        "qaAccess": false,
        "customRoles": false,
        "distributionRecipients": 3,
        "scheduledBundles": 1,
        "includedCreditsPerPeriod": 0
      },
      {
        "plan": "entry",
        "label": "Entry",
        "monthlyPriceUsdCents": 50000,
        "activeProjects": "unlimited",
        "clients": 5,
        "dataWindowDays": 365,
        "reportsPerMonth": 20,
        "syncFrequency": "daily",
        "qaAccess": true,
        "customRoles": false,
        "distributionRecipients": 25,
        "scheduledBundles": 10,
        "includedCreditsPerPeriod": 0
      },
      {
        "plan": "growth",
        "label": "Growth",
        "monthlyPriceUsdCents": 150000,
        "activeProjects": "unlimited",
        "clients": 25,
        "dataWindowDays": 365,
        "reportsPerMonth": "unlimited",
        "syncFrequency": "hourly",
        "qaAccess": true,
        "customRoles": true,
        "distributionRecipients": "unlimited",
        "scheduledBundles": "unlimited",
        "includedCreditsPerPeriod": 0
      }
    ]
  },
  "trial": {
    "catalogVersion": "v2",
    "plan": "growth",
    "label": "Growth",
    "plans": [
      { "plan": "starter", "label": "Starter" },
      { "plan": "growth", "label": "Growth" },
      { "plan": "scale", "label": "Scale" }
    ],
    "paymentMethodRequired": true,
    "days": 14,
    "includedCredits": 100
  },
  "creditPacks": {
    "catalogVersion": "credit-packs-2026-10",
    "packs": [
      {
        "pack": "pack-100",
        "credits": 100,
        "priceUsdCents": 2000,
        "expires": false
      },
      {
        "pack": "pack-500",
        "credits": 500,
        "priceUsdCents": 9000,
        "expires": false
      }
    ]
  },
  "aiAnalysis": {
    "catalogVersion": "ai-analysis-2026-10",
    "effectiveFrom": "2026-10-01",
    "maxOutputTokensPerAction": 2000,
    "cachedResultCredits": 0,
    "bands": [
      {
        "band": "8k",
        "maxInputTokens": 8000,
        "creditsPerAction": 1,
        "interpretationReviewCredits": 2
      },
      {
        "band": "32k",
        "maxInputTokens": 32000,
        "creditsPerAction": 4,
        "interpretationReviewCredits": 8
      },
      {
        "band": "128k",
        "maxInputTokens": 128000,
        "creditsPerAction": 16,
        "interpretationReviewCredits": 32
      }
    ]
  },
  "digest": {
    "algorithm": "sha256",
    "value": "7cb5bb137b87dc8f48bfd4e6ba4a3e29e3307a4cad7445084b781108a020a00c"
  }
}
